import React from 'react';
import {I18n} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';

import {CustomButton, CustomInput} from '../../material-dashboard-pro-react/components';
import {Close} from '../../icons';

import {ENTER_KEY_CODE} from '../../constants';
import {setSearchOption} from '../UsersConfigurer/action';

import style from './style';

/**
 * Controls for persona filtering
 */
class PersonasControls extends React.Component {
  nameSearchInput = (optionName, placeholder) => {
    const {classes, searchOptions, setSearchOption} = this.props;

    return (
      <CustomInput
        name="personaSearch"
        type="text"
        inputProps={{
          value: searchOptions[optionName] ?? '',
          disabled: this.props.disabled,
          onChange: (e) => setSearchOption(optionName, e.target.value.toLowerCase()),
          onKeyPress: this.onPersonaNameSearchKeyPressed,
          placeholder,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchOption(optionName, '')}>
                <Close />
              </IconButton>
            </InputAdornment>
          ),
        }}
        formControlProps={{
          className: classes.personasControls__nameSearchInputForm,
        }}
      />
    );
  };

  onPersonaNameSearchKeyPressed = (e) => {
    if (e.charCode === ENTER_KEY_CODE) {
      this.props.loadData();
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.loadData();
  };

  onReset = (e) => {
    e.preventDefault();
    this.props.reset();
  };

  render() {
    const {classes} = this.props;

    return (
      <form className={classes.personasControls}>
        <div className={classes.personasControls__row}>
          {this.nameSearchInput(
            'name',
            I18n.t('users.usersConfigurer.controls.placeholders.name'),
          )}
          {this.nameSearchInput(
            'adDomainName',
            I18n.t('users.usersConfigurer.controls.placeholders.adDomain'),
          )}
          {this.nameSearchInput(
            'entraTenantName',
            I18n.t('users.usersConfigurer.controls.placeholders.entraTenant'),
          )}

          <div className={classes.personasControls__row_buttons}>
            <CustomButton
            type="submit"
            color="secondary"
            customClasses="personas-controls__button"
            onClick={this.onSubmit}
            size="sm"
            >
              {I18n.t('buttons.submit').toUpperCase()}
            </CustomButton>
            <CustomButton
            color="gray"
            customClasses="personas-controls__button"
            onClick={this.onReset}
            size="sm"
            >
              {I18n.t('buttons.reset').toUpperCase()}
            </CustomButton>
          </div>
        </div>
      </form>
    );
  }
}

PersonasControls.propTypes = {
  classes: PropTypes.object.isRequired,
  loadData: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  setSearchOption: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  searchOptions: PropTypes.object.isRequired,
};

PersonasControls.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  setSearchOption,
};

const mapStateToProps = (state) => ({
  searchOptions: state.personaReducer.searchOptions,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(style)(PersonasControls));
